const synth = typeof window !== 'undefined' ? window.speechSynthesis : null;

export function isSpeechSupported() {
  return !!synth && typeof window.SpeechSynthesisUtterance === 'function';
}

function getVoices() {
  return new Promise((resolve) => {
    if (!synth) return resolve([]);
    const initial = synth.getVoices();
    if (initial.length) return resolve(initial);
    const onChange = () => {
      synth.removeEventListener('voiceschanged', onChange);
      resolve(synth.getVoices());
    };
    synth.addEventListener('voiceschanged', onChange);
    setTimeout(() => resolve(synth.getVoices()), 500);
  });
}

const PREFERRED = ['Samantha', 'Karen', 'Moira', 'Serena', 'Google US English', 'Microsoft Aria'];
let cachedVoice = null;

async function pickVoice() {
  const voices = await getVoices();
  for (const name of PREFERRED) {
    const match = voices.find((v) => v.name.includes(name));
    if (match) return match;
  }
  return voices.find((v) => v.lang?.startsWith('en')) || voices[0] || null;
}

export async function speak(text, { rate = 0.95, pitch = 1.0 } = {}) {
  if (!isSpeechSupported() || !text) return;
  if (!cachedVoice) cachedVoice = await pickVoice();
  synth.cancel();
  const u = new SpeechSynthesisUtterance(text);
  if (cachedVoice) u.voice = cachedVoice;
  u.rate = rate;
  u.pitch = pitch;
  return new Promise((resolve) => {
    u.onend = () => resolve();
    u.onerror = () => resolve();
    synth.speak(u);
  });
}

export function cancelSpeech() {
  if (synth) synth.cancel();
}
